<!-- 머니 한도 초과 안내 팝업 -->
<div class="surplus">
  <div class="surplus__shadow"></div>
  <div class="surplus__container">
    <h3 class="surplus__title">머니 한도 초과 안내</h3>
    <div class="surplus__content">
      <div class="surplus__user">
        <p>
          <strong>{{nickname}}님</strong>은 현재 
          {{#if (equal membership 'none')}}
            <strong>일반</strong>회원입니다.
          {{else}}
            <strong>{{membershipText}}</strong> 회원입니다.
          {{/if}}
        </p>
        <p>
          한도 <strong>{{{numberToTextTags moneyLimit}}} 골드</strong>를 초과한 머니는 만료 시간 이후 삭제됩니다.
        </p>
      </div>
      <div class="surplus__detail">
        <div class="surplus__detail-1">
          <span>만료 시간 :</span> <strong>{{excessMoneyExpireAt}}</strong>
        </div>
        <div class="surplus__detail-2">
          <span>초과 머니 :</span> <strong>{{{numberToShortTextTags excessMoney}}} 골드</strong>
        </div>
        <div class="surplus__detail-3"><span>보유 머니 :</span> <strong>{{{numberToShortTextTags totalMoney}}} 골드</strong></div>
      </div>
      <h4 class="surplus__guide">클래스별 머니총합 한도안내</h4>
      <div>{{membership}}</div>
      <table class="surplus__guide-table">
        <thead>
          <tr>
            <!-- active -->
            <th class="{{#if (equal membership 'none')}} active {{/if}}">일반</th>
            <th class="{{#if (equal membership 'silverclass')}} active {{/if}}">실버클래스</th>
            <th class="{{#if (equal membership 'goldclass')}} active {{/if}}">골드클래스</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <!-- active -->
            <td class="{{#if (equal membership 'none')}} active {{/if}}">300조</td>
            <td class="{{#if (equal membership 'silverclass')}} active {{/if}}">1000조</td>
            <td class="{{#if (equal membership 'goldclass')}} active {{/if}}">1500조</td>
          </tr>
        </tbody>
      </table>
      {{#if (equal membership 'royal')}}
      {{else}}
      <div class="surplus__membership">
        ※ 클래스 상품은 <strong>[게임 내>상점>클래스]</strong> 메뉴에서 가입할 수 있습니다
      </div>
      {{/if}}
      <div class="surplus__notice-1">
        ※ 클래스 해지 시 머니 총합은 일반고객과 동일하게 재조정되며 서비스 해지 후 차감된 조정액에
        대한 보상은 하지 않습니다.
      </div>
      <div class="surplus__notice-2">
        ※ 단, <strong>48시간</strong> 내에 재가입 시 조정된 머니는 다시 적립됩니다.
      </div>
      <a href="#" data-excess-click="confirm" class="surplus__close">닫기</a>
    </div>
  </div>
</div>
<!-- //머니 한도 초과 안내 팝업 -->
